<template>
  <div class="login-page theme-audra">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="card login-box position-relative">
            <div class="overlay text-center" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <!-- <div>
                <img :src="getImage('logo.svg')" alt="Dotlines" />
                <h3 class="card-common-title p-0 mb-3">Forgot your password?</h3>
                <form
                  @submit.prevent="forget_pass()"
                  method="POST"
                  class="response-alert"
                  novalidate
                >
  
                  <button type="submit" class="btn btn-common btn-block mb-5">Send</button>
  
                  <div class="text-center">
                    <router-link
                      class="pc fw-500 align-items-center d-inline-flex"
                      :to="{ name: 'Login' }"
                    >
                      <i style="font-size: 24px" class="icon-arrow-left-circle mr-2"></i>
                      Back to login
                    </router-link>
                  </div>
                </form>
              </div> -->
          </div>
        </div>
        <div class="col-md-4 ml-auto d-none d-sm-block">
          <div class="login-img">
            <h2><span>Enterprise</span> Grade Internet <strong>Security</strong>.</h2>
            <img class="like" src="/assets/images/like.png" alt="like" />
            <img class="sheild" src="/assets/images/sheild.png" alt="sheild" />
            <img class="wifi" src="/assets/images/wifi.png" alt="wifi" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GuestLayout from "@/components/layouts/GuestLayoutComponent.vue";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "Forgot Password | Dotlines",
      meta: [
        {
          name: "description",
          content: "The app built by Dotlines that is simply a framework",
        },
        {
          property: "og:title",
          content: "Forgot Password | Dotlines",
        },
      ],
    };
  },
  data: () => ({
    user: {},
    is_loading: false,
    pwd_reset_link_validation_url: "",
  }),
  methods: {
    forget_pass: function (e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const api_url = this.API_BASE_URL + "/auth/forgot-password";
          const token = "";
          const _this = this;
          this.is_loading = true;
          axios({
            method: "post",
            url: api_url,
            data: _this.user,
          })
            .then(function (response) {
              if (response.status === 200 && response.data.otp_success === true) {
                _this.$router.push({
                  name: "ResetPass",
                  params: { userInfo: response.data },
                });
              } else {
                $(".response-alert").prepend(
                  $(
                    '<div class="alert alert-danger alert-dismissible fade show" role="alert">\n' +
                      "    Invalid email or mobile no!\n" +
                      '    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
                      '       <span aria-hidden="true">&times;</span>\n' +
                      "    </button>\n" +
                      "</div>"
                  )
                );
              }
            })
            .catch(function (error) {
              if (error.response) {
                $(".response-alert").prepend(
                  $(
                    '<div class="alert alert-danger alert-dismissible fade show" role="alert">\n' +
                      error.response.data.message +
                      '    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
                      '       <span aria-hidden="true">&times;</span>\n' +
                      "    </button>\n" +
                      "</div>"
                  )
                );
                if (error.response.data.errors) {
                  _this.$toaster.error(error.response.data.errors.message);
                } else {
                  _this.$toaster.error(error.response.data.message);
                }
              } else if (error.request) {
                console.log(error.request);
              } else {
                console.log("Error", error.message);
              }

              _this.$router.push({ name: "Login" });
            })
            .finally(function () {
              _this.is_loading = false;
              _this.is_disabled = false;
              setTimeout(() => {
                $(".alert").fadeOut("slow");
              }, 5000);
            });

          console.warn(this.user);
        }
      });
    },
    verifyResetLink: function () {
      const _this = this;
      const protocol = window.location.protocol;
      const baseUrl = _this.pwd_reset_link_validation_url.includes("http")
        ? _this.pwd_reset_link_validation_url
        : "https://" + _this.pwd_reset_link_validation_url;

      const custom_url = baseUrl + "/api/auth/verify-reset-link";

      this.is_loading = true;

      axios({
        method: "post",
        url: custom_url,
        data: { uid: this.$route.query.uid },
      })
        .then(function (response) {
          if (response.data.is_valid === true) {
            _this.forget_pass();
          } else {
            _this.$toaster.error("The reset password link is invalid or expired.");
            _this.$router.push({ name: "Login" });
          }
        })
        .catch(function (error) {
          _this.$toaster.error("There was an issue validating the reset link.");
          _this.$router.push({ name: "Login" });
        })
        .finally(function () {});
    },
  },
  mounted: function () {
    localStorage.setItem("authenticate", false);
    localStorage.removeItem("token");

    let uid = atob(this.$route.query.uid);
    uid = uid.split("|");
    this.user.mobile_or_email = uid[0];
    this.pwd_reset_link_validation_url = uid[2];
    this.verifyResetLink();
  },
  created() {
    this.$emit("update:layout", GuestLayout);
  },
};
</script>
